import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const collectionItemsDefaultSortOrder = [Order.desc(OrderKeys.dateAdded)]; //TFS1076798 and 1083833 - [Order.asc(OrderKeys.position)];

export const collectionItemsSpecificSortOptions: OptionsDictionary = {
  // 'position': SortOptions.position,  // TFS1076798 and 1083833
  'dateAdded': SortOptions.dateAdded
};

export const collectionItemsMixedContentOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'type': SortOptions.type,
  'owner': SortOptions.mixedContentOwner,
  'updated': SortOptions.updated,
  ...collectionItemsSpecificSortOptions
};
